export default [
    {
        path: '/internal-support/messages',
        name: 'internalSuportMessageSend',
        component: () => import(/* webpackChunkName: "internalSupport" */ '../views/messages/Form.vue')
    },{
        path: '/internal-support/areas',
        name: 'internalSuportAreasList',
        component: () => import(/* webpackChunkName: "internalSupport" */ '../views/areas/List.vue')
    },
    {
        path: '/internal-support/areas/create',
        name: 'internalSuportAreasCreate',
        component: () => import(/* webpackChunkName: "internalSupport" */ '../views/areas/Form.vue')
    },
    {
        path: '/internal-support/areas/:id/edit',
        name: 'internalSuportAreasEdit',
        component: () => import(/* webpackChunkName: "internalSupport" */ '../views/areas/Form.vue')
    },
]